import { useState, useId, ReactNode } from 'react';

type P_CollapsibleSectionProps = {
  title: ReactNode;
  defaultOpen?: boolean;
  canToggle?: boolean;
  rightSlot?: ReactNode;
  className?: string;
  accentClassName?: string;
  contentClassName?: string;
  onToggle?: (open: boolean) => void;
  children: ReactNode;
};

const P_CollapsibleSection: React.FC<P_CollapsibleSectionProps> = ({
  title,
  defaultOpen = true,
  canToggle = true,
  rightSlot,
  className = '',
  accentClassName = 'border-fuchsia-600',
  contentClassName = '',
  onToggle,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const contentId = useId();

  return (
    <section className={`w-full ${className}`}>
      <div className={`border-t-2 ${accentClassName} mb-1`} />
      {canToggle ? (
        <button
          type="button"
          className="flex w-full items-center gap-2 text-lg font-semibold text-slate-800 "
          aria-expanded={open}
          aria-controls={contentId}
          onClick={() => {
            const next = !open;
            setOpen(next);
            onToggle?.(next);
          }}
        >
          <svg
            viewBox="0 0 12 12"
            className={`size-3 transition-transform ${open ? 'rotate-90' : ''}`}
            aria-hidden="true"
          >
            <path d="M4 2l4 4-4 4" fill="currentColor" />
          </svg>

          <span>{title}</span>
          <span className="ml-auto">{rightSlot}</span>
        </button>
      ) : (
        <span className="flex w-full items-center gap-2 text-lg font-semibold text-slate-800 ">
          {title}
        </span>
      )}

      <div
        id={contentId}
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className={['mt-2', contentClassName].join(' ')}>{children}</div>
        </div>
      </div>
    </section>
  );
};

export default P_CollapsibleSection;
